/** 告警设备图标
 */
// import BMap from 'BMap'

// 静态导入车辆图标
const carIcons = {
  '小轿车': {
    '静止': require('@/assets/images/车辆/小轿车/静止.png'),
    '行驶': require('@/assets/images/车辆/小轿车/行驶.png'),
    '报警': require('@/assets/images/车辆/小轿车/报警.png'),
    '离线': require('@/assets/images/车辆/小轿车/离线.png'),
    '休眠': require('@/assets/images/车辆/小轿车/休眠.png')
  },
  '越野车': {
    '静止': require('@/assets/images/车辆/越野车/静止.png'),
    '行驶': require('@/assets/images/车辆/越野车/行驶.png'),
    '报警': require('@/assets/images/车辆/越野车/报警.png'),
    '离线': require('@/assets/images/车辆/越野车/离线.png'),
    '休眠': require('@/assets/images/车辆/越野车/休眠.png')
  },
  '商务车（含面包）': {
    '静止': require('@/assets/images/车辆/商务车（含面包）/静止.png'),
    '行驶': require('@/assets/images/车辆/商务车（含面包）/行驶.png'),
    '报警': require('@/assets/images/车辆/商务车（含面包）/报警.png'),
    '离线': require('@/assets/images/车辆/商务车（含面包）/离线.png'),
    '休眠': require('@/assets/images/车辆/商务车（含面包）/休眠.png')
  },
  '中巴': {
    '静止': require('@/assets/images/车辆/中巴/静止.png'),
    '行驶': require('@/assets/images/车辆/中巴/行驶.png'),
    '报警': require('@/assets/images/车辆/中巴/报警.png'),
    '离线': require('@/assets/images/车辆/中巴/离线.png'),
    '休眠': require('@/assets/images/车辆/中巴/休眠.png')
  },
  '电力工程车': {
    '静止': require('@/assets/images/车辆/电力工程车/静止.png'),
    '行驶': require('@/assets/images/车辆/电力工程车/行驶.png'),
    '报警': require('@/assets/images/车辆/电力工程车/报警.png'),
    '离线': require('@/assets/images/车辆/电力工程车/离线.png'),
    '休眠': require('@/assets/images/车辆/电力工程车/休眠.png')
  },
  '汽车吊': {
    '静止': require('@/assets/images/车辆/汽车吊/静止.png'),
    '行驶': require('@/assets/images/车辆/汽车吊/行驶.png'),
    '报警': require('@/assets/images/车辆/汽车吊/报警.png'),
    '离线': require('@/assets/images/车辆/汽车吊/离线.png'),
    '休眠': require('@/assets/images/车辆/汽车吊/休眠.png')
  },
  '随车吊': {
    '静止': require('@/assets/images/车辆/随车吊/静止.png'),
    '行驶': require('@/assets/images/车辆/随车吊/行驶.png'),
    '报警': require('@/assets/images/车辆/随车吊/报警.png'),
    '离线': require('@/assets/images/车辆/随车吊/离线.png'),
    '休眠': require('@/assets/images/车辆/随车吊/休眠.png')
  },
  '货车': {
    '静止': require('@/assets/images/车辆/货车/静止.png'),
    '行驶': require('@/assets/images/车辆/货车/行驶.png'),
    '报警': require('@/assets/images/车辆/货车/报警.png'),
    '离线': require('@/assets/images/车辆/货车/离线.png'),
    '休眠': require('@/assets/images/车辆/货车/休眠.png')
  },
  '叉车': {
    '静止': require('@/assets/images/车辆/叉车/静止.png'),
    '行驶': require('@/assets/images/车辆/叉车/行驶.png'),
    '报警': require('@/assets/images/车辆/叉车/报警.png'),
    '离线': require('@/assets/images/车辆/叉车/离线.png'),
    '休眠': require('@/assets/images/车辆/叉车/休眠.png')
  },
  '挖掘机': {
    '静止': require('@/assets/images/车辆/挖掘机/静止.png'),
    '行驶': require('@/assets/images/车辆/挖掘机/行驶.png'),
    '报警': require('@/assets/images/车辆/挖掘机/报警.png'),
    '离线': require('@/assets/images/车辆/挖掘机/离线.png'),
    '休眠': require('@/assets/images/车辆/挖掘机/休眠.png')
  }
}

// 静态导入其他设备图标
const peopleIcons = {
  '静止': require('@/assets/images/人/静止.png'),
  '行驶': require('@/assets/images/人/行驶.png'),
  '报警': require('@/assets/images/人/报警.png'),
  '离线': require('@/assets/images/人/离线.png')
}

const capIcons = {
  '静止': require('@/assets/images/安全帽/静止.png'),
  '行驶': require('@/assets/images/安全帽/行驶.png'),
  '报警': require('@/assets/images/安全帽/报警.png'),
  '离线': require('@/assets/images/安全帽/离线.png')
}

const shipIcons = {
  '静止': require('@/assets/images/船/静止.png'),
  '行驶': require('@/assets/images/船/行驶.png'),
  '报警': require('@/assets/images/船/报警.png'),
  '离线': require('@/assets/images/船/离线.png')
}

const ztIcons = {
  '静止': require('@/assets/images/高精度/静止.png'),
  '行驶': require('@/assets/images/高精度/行驶.png'),
  '报警': require('@/assets/images/高精度/报警.png'),
  '离线': require('@/assets/images/高精度/离线.png')
}

const zjdIcons = {
  '静止': require('@/assets/images/中精度/静止.png'),
  '行驶': require('@/assets/images/中精度/行驶.png'),
  '报警': require('@/assets/images/中精度/报警.png'),
  '离线': require('@/assets/images/中精度/离线.png')
}

const otherIcons = {
  '静止': require('@/assets/images/其他设备/静止.png'),
  '行驶': require('@/assets/images/其他设备/行驶.png'),
  '报警': require('@/assets/images/其他设备/报警.png'),
  '离线': require('@/assets/images/其他设备/离线.png')
}

// 获取车辆图标路径的辅助函数
function getCarIconPath(carType, iconName) {
  const cleanIconName = iconName.replace('.png', '').replace('/', '')
  if (carIcons[carType] && carIcons[carType][cleanIconName]) {
    return carIcons[carType][cleanIconName]
  }
  // 默认返回小轿车的静止图标
  return carIcons['小轿车']['静止']
}
const cautionIcon = {
  /** 匹配告警和非告警状态图标和地图poopup html内容  百度地图
   * @param _this {object} 页面指针
   * @param data {string} 设备数据
   * @param icon {string} 图标容器
   */
  setIconAndPopupHtmlBDMap: function (_this, data) {
    // 设备型号集合，用于匹配设备图标
    let carKeyList = [5, 23, 24, 25, 26, 27, 28, 29, 32, 33, 42, 43, 40, 45]
    let peopleKeyList = [1, 4, 13, 14, 15, 16, 18, 20]
    let capKeyList = [2, 3, 19, 21, 22]
    let ztKeyList = [30, 17, 10]
    let shipList = [6, 31]
    let icon = null
    if (carKeyList.indexOf(data.devModel) > -1) {
      // 车设备
      let carClassificationDirs = ['小轿车', '越野车', '商务车（含面包）', '中巴', '电力工程车', '汽车吊', '随车吊', '货车', '叉车', '挖掘机']
      let carClassificationDir = carClassificationDirs[0]
      if (data.carClassification) {
        let index = data.carClassification - 1
        carClassificationDir = carClassificationDirs[index]
      }
      let iconUrl = ''
      if (data.status === 3) {
        iconUrl += '/离线.png'
      } else {
        if (data.cId !== null && data.cId !== '') {
          iconUrl += '/报警.png'
        } else {
          if (data.status === 1) {
            iconUrl += '/行驶.png'
          } else if (data.status === 2) {
            iconUrl += '/静止.png'
          } else if (data.status === 4) {
            iconUrl += '/休眠.png'
          } else if (data.status === null || data.status === '') {
            iconUrl += '/离线.png'
          }
        }
      }
      // 使用静态导入方式避免动态require问题
      let iconPath = getCarIconPath(carClassificationDir, iconUrl)
      icon = new BMap.Icon(iconPath, new BMap.Size(40, 40), {
        imageSize: new BMap.Size(40, 40)
      })
    } else if (peopleKeyList.indexOf(data.devModel) > -1) {
      // 人员设备
      let iconPath
      if (data.status === 3) {
        iconPath = peopleIcons['离线']
      } else {
        if (data.cId !== null && data.cId !== '') {
          iconPath = peopleIcons['报警']
        } else {
          if (data.status === 1) {
            iconPath = peopleIcons['行驶']
          } else if (data.status === 2) {
            iconPath = peopleIcons['静止']
          } else if (data.status === 4) {
            iconPath = peopleIcons['静止'] // 休眠状态使用静止图标
          } else if (data.status === null || data.status === '') {
            iconPath = peopleIcons['离线']
          } else {
            iconPath = peopleIcons['静止'] // 默认状态
          }
        }
      }
      icon = new BMap.Icon(iconPath, new BMap.Size(40, 40), {
        imageSize: new BMap.Size(40, 40)
      })
    } else if (capKeyList.indexOf(data.devModel) > -1) {
      // 安全帽设备
      let iconPath
      if (data.status === 3) {
        iconPath = capIcons['离线']
      } else {
        if (data.cId !== null && data.cId !== '') {
          iconPath = capIcons['报警']
        } else {
          if (data.status === 1) {
            iconPath = capIcons['行驶']
          } else if (data.status === 2) {
            iconPath = capIcons['静止']
          } else if (data.status === 4) {
            iconPath = capIcons['静止'] // 休眠状态使用静止图标
          } else if (data.status === null || data.status === '') {
            iconPath = capIcons['离线']
          } else {
            iconPath = capIcons['静止'] // 默认状态
          }
        }
      }
      icon = new BMap.Icon(iconPath, new BMap.Size(40, 40), {
        imageSize: new BMap.Size(40, 40)
      })
    } else if (shipList.indexOf(data.devModel) > -1) {
      // 船设备
      let iconPath
      if (data.status === 3) {
        iconPath = shipIcons['离线']
      } else {
        if (data.cId !== null && data.cId !== '') {
          iconPath = shipIcons['报警']
        } else {
          if (data.status === 1) {
            iconPath = shipIcons['行驶']
          } else if (data.status === 2) {
            iconPath = shipIcons['静止']
          } else if (data.status === 4) {
            iconPath = shipIcons['静止'] // 休眠状态使用静止图标
          } else if (data.status === null || data.status === '') {
            iconPath = shipIcons['离线']
          } else {
            iconPath = shipIcons['静止'] // 默认状态
          }
        }
      }
      icon = new BMap.Icon(iconPath, new BMap.Size(40, 40), {
        imageSize: new BMap.Size(40, 40)
      })
    } else if (ztKeyList.indexOf(data.devModel) > -1) {
      // 锥桶设备
      let iconPath
      if (data.devModel === 30) {
        // 高精度
        if (data.status === 3) {
          iconPath = ztIcons['离线']
        } else {
          if (data.cId !== null && data.cId !== '') {
            iconPath = ztIcons['报警']
          } else {
            if (data.status === 1) {
              iconPath = ztIcons['行驶']
            } else if (data.status === 2) {
              iconPath = ztIcons['静止']
            } else if (data.status === 4) {
              iconPath = ztIcons['静止'] // 休眠状态使用静止图标
            } else if (data.status === null || data.status === '') {
              iconPath = ztIcons['离线']
            } else {
              iconPath = ztIcons['静止'] // 默认状态
            }
          }
        }
      } else {
        // 中精度设备
        if (data.status === 3) {
          iconPath = zjdIcons['离线']
        } else {
          if (data.cId !== null && data.cId !== '') {
            iconPath = zjdIcons['报警']
          } else {
            if (data.status === 1) {
              iconPath = zjdIcons['行驶']
            } else if (data.status === 2) {
              iconPath = zjdIcons['静止']
            } else if (data.status === 4) {
              iconPath = zjdIcons['静止'] // 休眠状态使用静止图标
            } else if (data.status === null || data.status === '') {
              iconPath = zjdIcons['离线']
            } else {
              iconPath = zjdIcons['静止'] // 默认状态
            }
          }
        }
      }
      icon = new BMap.Icon(iconPath, new BMap.Size(40, 40), {
        imageSize: new BMap.Size(40, 40)
      })
    } else {
      // 其他设备
      let iconPath
      if (data.status === 3) {
        iconPath = otherIcons['离线']
      } else {
        if (data.cId !== null && data.cId !== '') {
          iconPath = otherIcons['报警']
        } else {
          if (data.status === 1) {
            iconPath = otherIcons['行驶']
          } else if (data.status === 2) {
            iconPath = otherIcons['静止']
          } else if (data.status === 4) {
            iconPath = otherIcons['静止'] // 休眠状态使用静止图标
          } else if (data.status === null || data.status === '') {
            iconPath = otherIcons['离线']
          } else {
            iconPath = otherIcons['静止'] // 默认状态
          }
        }
      }
      icon = new BMap.Icon(iconPath, new BMap.Size(40, 40), {
        imageSize: new BMap.Size(40, 40)
      })
    }
    return icon
  },
  /**
   * 已弃用
   * 匹配告警和非告警状态图标和地图poopup html内容  leaflet
   * @param _this {object} 页面指针
   * @param data {string} 设备数据
   * @param icon {string} 图标容器
   */
  setIconAndPopupHtmlLLMap: function (_this, data) {
    console.log('setIconAndPopupHtmlLLMap', data.devModel)
    let carKeyList = [5, 23, 24, 25, 26, 27, 28, 29, 32, 33, 42, 43, 40, 45]
    let peopleKeyList = [1, 4, 13, 14, 15, 16, 18, 20]
    let capKeyList = [2, 3, 19, 21, 22]
    let ztKeyList = [30, 17, 10]
    let shipList = [6, 31]
    let icon = null
    if (carKeyList.indexOf(data.devModel) > -1) {
      // 车辆设备
      if (data.status === 3) {
        icon = _this.$L.icon({
          iconUrl: require('../../assets/images/车辆/离线.png'),
          iconSize: [40, 40]
        })
      } else {
        if (data.cId !== null && data.cId !== '') {
          icon = _this.$L.icon({
            iconUrl: require('../../assets/images/车辆/报警.png'),
            iconSize: [40, 40]
          })
        } else {
          if (data.status === 1) {
            icon = _this.$L.icon({
              iconUrl: require('../../assets/images/车辆/行驶.png'),
              iconSize: [40, 40]
            })
          } else if (data.status === 2) {
            icon = _this.$L.icon({
              iconUrl: require('../../assets/images/车辆/静止.png'),
              iconSize: [40, 40]
            })
          } else if (data.status === 4) {
            icon = _this.$L.icon({
              iconUrl: require('../../assets/images/车辆/休眠.png'),
              iconSize: [40, 40]
            })
          } else if (data.status === null || data.status === '') {
            icon = _this.$L.icon({
              iconUrl: require('../../assets/images/车辆/离线.png'),
              iconSize: [40, 40]
            })
          }
        }
      }
    } else if (shipList.indexOf(data.devModel) > -1) {
      // 船设备
      if (data.status === 3) {
        icon = _this.$L.icon({
          iconUrl: require('../../assets/images/船/离线.png'),
          iconSize: [40, 40]
        })
      } else {
        if (data.cId !== null && data.cId !== '') {
          icon = _this.$L.icon({
            iconUrl: require('../../assets/images/船/报警.png'),
            iconSize: [40, 40]
          })
        } else {
          if (data.status === 1) {
            icon = _this.$L.icon({
              iconUrl: require('../../assets/images/船/行驶.png'),
              iconSize: [40, 40]
            })
          } else if (data.status === 2) {
            icon = _this.$L.icon({
              iconUrl: require('../../assets/images/船/静止.png'),
              iconSize: [40, 40]
            })
          } else if (data.status === 4) {
            icon = _this.$L.icon({
              iconUrl: require('../../assets/images/船/休眠.png'),
              iconSize: [40, 40]
            })
          } else if (data.status === null || data.status === '') {
            icon = _this.$L.icon({
              iconUrl: require('../../assets/images/船/离线.png'),
              iconSize: [40, 40]
            })
          }
        }
      }
    } else if (peopleKeyList.indexOf(data.devModel) > -1) {
      // 人员设备
      if (data.status === 3) {
        icon = _this.$L.icon({
          iconUrl: require('../../assets/images/人/离线.png'),
          iconSize: [40, 40]
        })
      } else {
        if (data.cId !== null && data.cId !== '') {
          icon = _this.$L.icon({
            iconUrl: require('../../assets/images/人/报警.png'),
            iconSize: [40, 40]
          })
        } else {
          if (data.status === 1) {
            icon = _this.$L.icon({
              iconUrl: require('../../assets/images/人/行驶.png'),
              iconSize: [40, 40]
            })
          } else if (data.status === 2) {
            icon = _this.$L.icon({
              iconUrl: require('../../assets/images/人/静止.png'),
              iconSize: [40, 40]
            })
          } else if (data.status === 4) {
            icon = _this.$L.icon({
              iconUrl: require('../../assets/images/人/休眠.png'),
              iconSize: [40, 40]
            })
          } else if (data.status === null || data.status === '') {
            icon = _this.$L.icon({
              iconUrl: require('../../assets/images/人/离线.png'),
              iconSize: [40, 40]
            })
          }
        }
      }
    } else if (capKeyList.indexOf(data.devModel) > -1) {
      // 安全帽设备
      if (data.status === 3) {
        icon = _this.$L.icon({
          iconUrl: require('../../assets/images/安全帽/离线.png'),
          iconSize: [40, 40]
        })
      } else {
        if (data.cId !== null && data.cId !== '') {
          icon = _this.$L.icon({
            iconUrl: require('../../assets/images/安全帽/报警.png'),
            iconSize: [40, 40]
          })
        } else {
          if (data.status === 1) {
            icon = _this.$L.icon({
              iconUrl: require('../../assets/images/安全帽/行驶.png'),
              iconSize: [40, 40]
            })
          } else if (data.status === 2) {
            icon = _this.$L.icon({
              iconUrl: require('../../assets/images/安全帽/静止.png'),
              iconSize: [40, 40]
            })
          } else if (data.status === 4) {
            icon = _this.$L.icon({
              iconUrl: require('../../assets/images/安全帽/休眠.png'),
              iconSize: [40, 40]
            })
          } else if (data.status === null || data.status === '') {
            icon = _this.$L.icon({
              iconUrl: require('../../assets/images/安全帽/离线.png'),
              iconSize: [40, 40]
            })
          }
        }
      }
    } else if (ztKeyList.indexOf(data.devModel) > -1) {
      // 锥桶设备
      if (data.devModel === 30) {
        // 高精度
        if (data.status === 3) {
          icon = _this.$L.icon({
            iconUrl: require('../../assets/images/高精度/离线.png'),
            iconSize: [40, 40]
          })
        } else {
          if (data.cId !== null && data.cId !== '') {
            icon = _this.$L.icon({
              iconUrl: require('../../assets/images/高精度/报警.png'),
              iconSize: [40, 40]
            })
          } else {
            if (data.status === 1) {
              icon = _this.$L.icon({
                iconUrl: require('../../assets/images/高精度/行驶.png'),
                iconSize: [40, 40]
              })
            } else if (data.status === 2) {
              icon = _this.$L.icon({
                iconUrl: require('../../assets/images/高精度/静止.png'),
                iconSize: [40, 40]
              })
            } else if (data.status === 4) {
              icon = _this.$L.icon({
                iconUrl: require('../../assets/images/高精度/休眠.png'),
                iconSize: [40, 40]
              })
            } else if (data.status === null || data.status === '') {
              icon = _this.$L.icon({
                iconUrl: require('../../assets/images/高精度/离线.png'),
                iconSize: [40, 40]
              })
            }
          }
        }
      } else {
        // 中精度锥桶
        if (data.status === 3) {
          icon = _this.$L.icon({
            iconUrl: require('../../assets/images/中精度/离线.png'),
            iconSize: [40, 40]
          })
        } else {
          if (data.cId !== null && data.cId !== '') {
            icon = _this.$L.icon({
              iconUrl: require('../../assets/images/中精度/报警.png'),
              iconSize: [40, 40]
            })
          } else {
            if (data.status === 1) {
              icon = _this.$L.icon({
                iconUrl: require('../../assets/images/中精度/行驶.png'),
                iconSize: [40, 40]
              })
            } else if (data.status === 2) {
              icon = _this.$L.icon({
                iconUrl: require('../../assets/images/中精度/静止.png'),
                iconSize: [40, 40]
              })
            } else if (data.status === 4) {
              icon = _this.$L.icon({
                iconUrl: require('../../assets/images/中精度/休眠.png'),
                iconSize: [40, 40]
              })
            } else if (data.status === null || data.status === '') {
              icon = _this.$L.icon({
                iconUrl: require('../../assets/images/中精度/离线.png'),
                iconSize: [40, 40]
              })
            }
          }
        }
      }
    } else {
      // 其他设备
      if (data.status === 3) {
        icon = _this.$L.icon({
          iconUrl: require('../../assets/images/其他设备/离线.png'),
          iconSize: [40, 40]
        })
      } else {
        if (data.cId !== null && data.cId !== '') {
          icon = _this.$L.icon({
            iconUrl: require('../../assets/images/其他设备/报警.png'),
            iconSize: [40, 40]
          })
        } else {
          if (data.status === 1) {
            icon = _this.$L.icon({
              iconUrl: require('../../assets/images/其他设备/行驶.png'),
              iconSize: [40, 40]
            })
          } else if (data.status === 2) {
            icon = _this.$L.icon({
              iconUrl: require('../../assets/images/其他设备/静止.png'),
              iconSize: [40, 40]
            })
          } else if (data.status === 4) {
            icon = _this.$L.icon({
              iconUrl: require('../../assets/images/其他设备/休眠.png'),
              iconSize: [40, 40]
            })
          } else if (data.status === null || data.status === '') {
            icon = _this.$L.icon({
              iconUrl: require('../../assets/images/其他设备/离线.png'),
              iconSize: [40, 40]
            })
          }
        }
      }
    }
    return icon
  },
  /**
   * 已弃用
   * 匹配告警和非告警状态图标和地图poopup html内容  leaflet
   * @param _this {object} 页面指针
   * @param data {string} 设备数据
   * @param icon {string} 图标容器
   */
  setIconAndPopupHtmlMissionMap: function (_this, data) {
    let capKeyList = [2, 3, 19, 21, 22]
    let ztKeyList = [30, 17, 10]
    let icon = null
    let cautionStr = ''
    if (capKeyList.indexOf(data.devModel)) {
      // 安全帽
      if (data.flag === false || data.cId !== '') {
        // 报警（flag 围栏报警  cId 硬件报警）
        icon = new BMap.Icon(require('../../assets/images/安全帽/报警.png'), new BMap.Size(30, 30), {
          imageSize: new BMap.Size(30, 30)
        })
        let cIdList = data.cId.split(',')
        for (let item in cIdList) {
          for (let i in _this.dictionaryList) {
            if (_this.dictionaryList[i].dKey === cIdList[item] && _this.dictionaryList[i].dType === 'CAUTION_TYPE') {
              cautionStr = cautionStr + _this.dictionaryList[i].dValue + '，'
            }
          }
        }
        if (data.flag === false) {
          cautionStr = cautionStr + '[出围栏]'
        }
      } else {
        // 正常
        icon = new BMap.Icon(require('../../assets/images/安全帽/行驶.png'), new BMap.Size(30, 30), {
          imageSize: new BMap.Size(30, 30)
        })
        cautionStr = '[围栏内]'
      }
    } else if (ztKeyList.indexOf(data.devModel)) {
      // 锥桶
      if (data.cId !== '' && data.cId !== null) {
        // 报警（cId 硬件报警）
        icon = new BMap.Icon(require('../../assets/images/高精度/报警.png'), new BMap.Size(30, 30), {
          imageSize: new BMap.Size(30, 30)
        })
        let cIdList = data.cId.split(',')
        for (let item in cIdList) {
          for (let i in _this.dictionaryList) {
            if (_this.dictionaryList[i].dKey === cIdList[item] && _this.dictionaryList[i].dType === 'CAUTION_TYPE') {
              cautionStr = cautionStr + _this.dictionaryList[i].dValue + '，'
            }
          }
        }
      } else {
        // 正常
        icon = new BMap.Icon(require('../../assets/images/高精度/报警.png'), new BMap.Size(30, 30), {
          imageSize: new BMap.Size(30, 30)
        })
      }
    }
    return {
      icon: icon,
      cautionStr: cautionStr
    }
  },

  /**
   * 匹配告警和非告警状态图标和地图popup html内容  高德地图
   * @param _this {object} 页面指针
   * @param data {string} 设备数据
   */
  setIconAndPopupHtmlGDMap: function (_this, data) {
    // 设备型号集合，用于匹配设备图标
    let carKeyList = [5, 23, 24, 25, 26, 27, 28, 29, 32, 33, 42, 43, 40, 45]
    let peopleKeyList = [1, 4, 13, 14, 15, 16, 18, 20]
    let capKeyList = [2, 3, 19, 21, 22]
    let ztKeyList = [30, 17, 10]
    let shipList = [6, 31]
    let iconUrl = ''

    if (carKeyList.indexOf(data.devModel) > -1) {
      // 车设备
      let carClassificationDirs = ['小轿车', '越野车', '商务车（含面包）', '中巴', '电力工程车', '汽车吊', '随车吊', '货车', '叉车', '挖掘机']
      let carClassificationDir = carClassificationDirs[0]
      if (data.carClassification) {
        let index = data.carClassification - 1
        carClassificationDir = carClassificationDirs[index]
      }

      if (data.status === 3) {
        iconUrl = getCarIconPath(carClassificationDir, '/离线.png')
      } else {
        if (data.cId !== null && data.cId !== '') {
          iconUrl = getCarIconPath(carClassificationDir, '/报警.png')
        } else {
          if (data.status === 1) {
            iconUrl = getCarIconPath(carClassificationDir, '/行驶.png')
          } else if (data.status === 2) {
            iconUrl = getCarIconPath(carClassificationDir, '/静止.png')
          } else if (data.status === 4) {
            iconUrl = getCarIconPath(carClassificationDir, '/休眠.png')
          } else if (data.status === null || data.status === '') {
            iconUrl = getCarIconPath(carClassificationDir, '/离线.png')
          }
        }
      }
    } else if (peopleKeyList.indexOf(data.devModel) > -1) {
      // 人员设备
      if (data.status === 3) {
        iconUrl = peopleIcons['离线']
      } else {
        if (data.cId !== null && data.cId !== '') {
          iconUrl = peopleIcons['报警']
        } else {
          if (data.status === 1) {
            iconUrl = peopleIcons['行驶']
          } else if (data.status === 2) {
            iconUrl = peopleIcons['静止']
          } else if (data.status === 4) {
            iconUrl = peopleIcons['静止'] // 休眠状态使用静止图标
          } else if (data.status === null || data.status === '') {
            iconUrl = peopleIcons['离线']
          }
        }
      }
    } else if (capKeyList.indexOf(data.devModel) > -1) {
      // 安全帽设备
      if (data.status === 3) {
        iconUrl = capIcons['离线']
      } else {
        if (data.cId !== null && data.cId !== '') {
          iconUrl = capIcons['报警']
        } else {
          if (data.status === 1) {
            iconUrl = capIcons['行驶']
          } else if (data.status === 2) {
            iconUrl = capIcons['静止']
          } else if (data.status === 4) {
            iconUrl = capIcons['静止'] // 休眠状态使用静止图标
          } else if (data.status === null || data.status === '') {
            iconUrl = capIcons['离线']
          }
        }
      }
    } else if (shipList.indexOf(data.devModel) > -1) {
      // 船设备
      if (data.status === 3) {
        iconUrl = shipIcons['离线']
      } else {
        if (data.cId !== null && data.cId !== '') {
          iconUrl = shipIcons['报警']
        } else {
          if (data.status === 1) {
            iconUrl = shipIcons['行驶']
          } else if (data.status === 2) {
            iconUrl = shipIcons['静止']
          } else if (data.status === 4) {
            iconUrl = shipIcons['静止'] // 休眠状态使用静止图标
          } else if (data.status === null || data.status === '') {
            iconUrl = shipIcons['离线']
          }
        }
      }
    } else if (ztKeyList.indexOf(data.devModel) > -1) {
      // 锥桶设备
      if (data.devModel === 30) {
        // 高精度
        if (data.status === 3) {
          iconUrl = ztIcons['离线']
        } else {
          if (data.cId !== null && data.cId !== '') {
            iconUrl = ztIcons['报警']
          } else {
            if (data.status === 1) {
              iconUrl = ztIcons['行驶']
            } else if (data.status === 2) {
              iconUrl = ztIcons['静止']
            } else if (data.status === 4) {
              iconUrl = ztIcons['静止'] // 休眠状态使用静止图标
            } else if (data.status === null || data.status === '') {
              iconUrl = ztIcons['离线']
            }
          }
        }
      } else {
        // 中精度设备
        if (data.status === 3) {
          iconUrl = zjdIcons['离线']
        } else {
          if (data.cId !== null && data.cId !== '') {
            iconUrl = zjdIcons['报警']
          } else {
            if (data.status === 1) {
              iconUrl = zjdIcons['行驶']
            } else if (data.status === 2) {
              iconUrl = zjdIcons['静止']
            } else if (data.status === 4) {
              iconUrl = zjdIcons['静止'] // 休眠状态使用静止图标
            } else if (data.status === null || data.status === '') {
              iconUrl = zjdIcons['离线']
            }
          }
        }
      }
    } else {
      // 其他设备
      if (data.status === 3) {
        iconUrl = otherIcons['离线']
      } else {
        if (data.cId !== null && data.cId !== '') {
          iconUrl = otherIcons['报警']
        } else {
          if (data.status === 1) {
            iconUrl = otherIcons['行驶']
          } else if (data.status === 2) {
            iconUrl = otherIcons['静止']
          } else if (data.status === 4) {
            iconUrl = otherIcons['静止'] // 休眠状态使用静止图标
          } else if (data.status === null || data.status === '') {
            iconUrl = otherIcons['离线']
          }
        }
      }
    }

    return new window.AMap.Icon({
      image: iconUrl,
      size: new window.AMap.Size(40, 40),
      imageSize: new window.AMap.Size(40, 40)
    })
  }
}

export default cautionIcon



// WEBPACK FOOTER //
// ./src/javascript/function/CautionIconFun.js